import React from 'react';

import { Input, Select } from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Box } from '../../shared/components';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import FiltrableTable from '../../shared/containers/filtrableTable.grideable.deprecated';
import {
  gridSetFilterAction,
  gridSetTiendaFilterAction,
} from '../../../state/actions/creators/grideable.actioncreator';
import { debounce } from '../../../helpers/common.helper';
import { isTablet, isTotem } from '../../../helpers/device.helper';
import {faSearch} from "@fortawesome/pro-light-svg-icons/faSearch";

const { Option } = Select;
//TODO: A eliminar
class PacientesFiltrableTable extends React.Component {
  buscar = debounce(() => {
    this.grideableTableRef.buscar();
  }, 500);

  constructor(props) {
    super(props);
    this.state = {
      textoBusqueda: undefined,
    };
  }

  onTiendaChange({ tiendaId }) {
    const { endpoint, gridSetTiendaFilterAction } = this.props;
    gridSetTiendaFilterAction({ endpoint, tiendaId });
    this.grideableTableRef.buscar();
  }

  cambiarFiltroTexto = ({ texto }) => {
    const { endpoint, gridSetFilterAction } = this.props;

    this.setState({ textoBusqueda: texto });
    const filters = {
      nombre_completo: undefined,
    };
    if (texto && texto.length > 1) {
      filters.nombre_completo = { valor: texto, operador: 'like' };
    }
    gridSetFilterAction({
      endpoint,
      filters,
    });
  }

  render() {
    const { serverResponse, columns } = this.props;
    const { tiendaId: tiendaIdSeleccionada, running } = serverResponse;
    const { textoBusqueda } = this.state;
    const { tiendas, endpoint } = this.props;
    const Options = tiendas.filter(tienda => tienda.obsoleta !== true).map(tienda => <Option key={tienda.id} value={tienda.id}>{tienda.nombre}</Option>);
    return (
      <Box>
        <TwoColumnsFlexLayout
          pb="16"
          flexLeft={4}
          flexRight={1}
          leftContent={(
            <Input
              autoFocus
              suffix={<FontAwesomeIcon onClick={() => this.grideableTableRef.buscar()} icon={faSearch} />}
              readOnly={running === true}
              className={running === true ? 'disabled-readonly' : null}
              onChange={(e) => {
                const text = e.target.value;
                if (text !== undefined) {
                  const porcionesTexto = text.trim().split(" ");
                  let busqueda = '';
                  porcionesTexto.forEach((porcion) => {
                    busqueda += `${porcion}% `;
                  });
                  this.cambiarFiltroTexto({ texto: busqueda.trim() });
                }
                if (!isTablet() && !isTotem()) {
                  this.buscar();
                }
              }}
              onPressEnter={() => this.grideableTableRef.buscar()}
            />
          )}
          value={textoBusqueda}
          rightContent={(
            <Select
              disabled={running === true}
              allowClear
              placeholder="Todas las tiendas"
              value={tiendaIdSeleccionada!==null ? tiendaIdSeleccionada : undefined}
              style={{ width: '100%' }}
              onChange={tiendaId => this.onTiendaChange({ tiendaId })}
            >
              {Options}
            </Select>
          )}
          rightColumnStyle={{ paddingLeft: '16px' }}
        />
        <FiltrableTable
          {...this.props}
          endpoint={endpoint}
          onRef={ref => (this.grideableTableRef = ref)}
          url="api/pacientes/buscar"
          tiendaId={tiendaIdSeleccionada}
          columns={columns}
        />
      </Box>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { core: { tiendas }, grideable } = state;
  const { endpoint } = ownProps;
  let serverResponse = {
    running: null, success: null, datos: [], pagination: {}, tiendaId: null,
  };
  if (grideable && grideable[endpoint]) {
    serverResponse = grideable[endpoint];
  }
  return {
    tiendas,
    serverResponse,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    gridSetFilterAction,
    gridSetTiendaFilterAction,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PacientesFiltrableTable);

PacientesFiltrableTable.propTypes = {
  columns: PropTypes.any,
  endpoint: PropTypes.string.isRequired,
  gridSetFilterAction: PropTypes.func.isRequired,
  gridSetTiendaFilterAction: PropTypes.func.isRequired,
  serverResponse: PropTypes.any.isRequired,
  tiendas: PropTypes.any,
};

PacientesFiltrableTable.defaultProps = {
  columns: [],
  tiendas: [],
};
